import './confirmation-item.css'
import React from 'react'
import { HiOutlinePencil } from "react-icons/hi";
import { useNavigate } from 'react-router-dom'
import { useNavigation } from "../../../hooks/navigationContext";

const ConfirmationItem = ({ Item, Description, Action }) => {

    const navigate = useNavigate();
    const { setDirection } = useNavigation();

    const action = () => {
        setDirection(-1);
        navigate(Action);
    }

    return (
        <button className='confirmation-item' onClick={action}>
            <div >
                <span className='app-little-text'>{Item}</span>

                <div className='confirmation-description'>
                    <span className='app-text'>{Description}</span>
                </div>
            </div>

            {Action && (
                <div className="change-icon">
                    Alterar <HiOutlinePencil />
                </div>
            )}
        </button>
    )
}

export default ConfirmationItem